export const API_URL = process.env.API_URL
export const REACT_APP_STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY